import Swiper from 'swiper/bundle';
// import styles bundle
import 'swiper/css/bundle';

export default class Sliders {

  offer() {
    new Swiper(".offer-slider", {
      loop: true,
      autoHeight: true,
      preloadImages: false,
      lazy: true,
      // navigation: {
      //   nextEl: '.products-slider-next',
      // },
      autoplay: {
  			delay: 5000,
  		},
    });
  }

  products() {

    $('.product-slider').each(function(index) {

      var $nav = $(this).parent().find('.product-slider-nav');
      var nav_next_class = "product-next-" + index;
      var nav_prev_class = "product-prev-" + index;

      $nav.find('.product-slider-nav-next').addClass(nav_next_class);
      $nav.find('.product-slider-nav-prev').addClass(nav_prev_class);
      

      new Swiper($(this)[0], {
        loop: true,
        //autoHeight: true,
        preloadImages: false,
        lazy: true,
        navigation: {
          nextEl: '.' + nav_next_class,
          prevEl: '.' + nav_prev_class,
        },
        autoplay: {
    			delay: 5000,
    		},
      });

    });

  }


  news() {

      new Swiper(".news-slider", {
        loop: true,
        slidesPerView: 1,
        //autoHeight: true,
        preloadImages: false,
        lazy: true,
        navigation: {
          nextEl: '.news-slider-next',
          prevEl: '.news-slider-prev',
        },
        autoplay: {
    			delay: 5000,
    		},
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 40,
          },
          992: {
            slidesPerView: 3,
            spaceBetween: 40,
          },
          1360: {
            slidesPerView: 3,
            spaceBetween: 80,
          },
        }
      });
  }

    gallery() {

      var thumbs = new Swiper ('.gallery-thumbs', {
        slidesPerView: 'auto',
      });

      new Swiper(".gallery-slider", {
        loop: true,
        autoHeight: true,
        preloadImages: false,
        lazy: true,
        navigation: {
					nextEl: '.gallery-slider-nav-next',
          prevEl: '.gallery-slider-nav-prev',
				},
        thumbs: {
          swiper: thumbs
        },
        // autoplay: {
		// 			delay: 5000,
		// 		},
      });

    }

  
    init() {
      document.querySelector('.offer-slider') ? this.offer() : null;
      document.querySelector('.product-slider') ? this.products() : null;
      document.querySelector('.news-slider') ? this.news() : null;
      document.querySelector('.product-gallery') ? this.gallery() : null;
      
    }
}